// src/components/ProductCard.js (Corrected Version)

import React from 'react';
import { useNavigate } from 'react-router-dom';

// 1. Remove `onClick` from the props. The component no longer needs it.
const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  
  // Your image URL logic is perfect.
  const prefixedMainImage = product.mainImage && product.mainImage.startsWith('http')
    ? product.mainImage
    : `https://apiqms.shigjeta.com${product.mainImage}`;

  // 2. Rename your internal function to something unique, like `handleCardClick`.
  const handleCardClick = () => {
    if (product.id) {
      navigate(`/shigjeta-shop/${product.id}`);
    } else {
      console.error("Product Card Error: Product is missing an 'id' property.", product);
    }
  };

  return (
    // 3. Use your new, correctly named function in the onClick event.
    <div className="shop-product-card" onClick={handleCardClick}>
      <img src={prefixedMainImage} alt={product.name} />
      {/* It's better to use product.name here for consistency with your data */}
      <h3 className="product-title">{product.name}</h3>
    </div>
  );
};

export default ProductCard;